import { UIElement } from "../common_ui_elements/ui_element.js";
import { Vector2 } from "../../common/vector2.js";
import { OverlayId } from "./overlay_ids.js";

export abstract class AbstractOverlay extends UIElement
{
  protected params: any;
  protected closeOnBackgroundClick: boolean;
  private overlay_id: OverlayId;

  constructor( ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, overlay_id: OverlayId, params?: any, closeOnBackgroundClick: boolean = true )
  {
    super( ctx, x, y, width, height );
    this.overlay_id = overlay_id;
    this.params = params;
    this.closeOnBackgroundClick = closeOnBackgroundClick;
  }

  public getId(): OverlayId
  {
    return this.overlay_id;
  }

  public update( now: number ): void
  {
    this.updateBasic( now );
  }

  abstract render(): void;
  abstract name(): string;

  public onOverlayWillClose(): void {}

  public drawsOwnBackground(): boolean
  {
    return false;
  }

  public containsPointGlobal( p: Vector2 ): boolean
  {
    const pixel_pos = this.pixelPosForRender();

    const x = pixel_pos.x + this.rect.getX();
    const y = pixel_pos.y + this.rect.getY();
    const w = this.rect.getW();
    const h = this.rect.getH();

    return p.x > x
      && p.y > y
      && p.x < x + w
      && p.y < y + h;
  }

  public getCenterGlobal(): Vector2
  {
    const pixel_pos = this.pixelPosForRender();
    return new Vector2(
      pixel_pos.x + this.rect.getX() + this.rect.getW() / 2,
      pixel_pos.y + this.rect.getY() + this.rect.getH() / 2
    );
  }

  public getCloseOnBackgroundClick(): boolean
  {
    return this.closeOnBackgroundClick;
  }

  public getParams(): any
  {
    return this.params;
  }
}
